import { NewDynamicTab } from "../../../components/Page";
import { JvvnlGeneration as JvvnlGenerationDates } from "../../../config/DefaultDates";
import { JvvnlTitle, TabSwitcher } from "../Jvnnl_Dashboard";
import JvvnlGlobalSearch from "../../../components/Search/Jvvnl/GlobalSearch";
import ForecastPrediction from "./ForecastPrediction";

export function JvvnlForecast() {
  return (
    <NewDynamicTab
      headerPrefixComponent={<TabSwitcher />}
      rightPrefixComponent={<JvvnlGlobalSearch />}
      defaultDates={JvvnlGenerationDates}
      header=""
      middleComponent={<JvvnlTitle />}
      showTabs={false}
      tabs={{ "Net Load & DRE Flow": <ForecastPrediction /> }}
      showDates={false}
      showReactSelect={false}
    />
  );
}
